import React, { useState, useEffect } from "react";
import styles from "./Header.module.css";
import { Link } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import commonStyles from "../commonStyles.module.css";
import { FaPhone } from "react-icons/fa";
import { useLocation } from "react-router-dom";

function Header(props) {

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {

    // Close the menu when the location changes
    setIsMenuOpen(false);

  }, [location]);
  return (
    <header>
      <nav className={styles.nav} aria-label="Main navigation">
        <div className={styles.navLogo}>
          <button
            className={styles.navToggle}
            id="navToggle"
            aria-expanded={isMenuOpen}
            aria-controls="navLinks"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            Menu
          </button>
           <Link className={styles.logo} to="/">
          <img
            className={styles.logoImg}
            src="/Images/Content/mh-transparent-logo-only.png"
            alt="Match Hampers Logo"
          />
           </Link>
          <Link className={styles.logo} to="/">
            <span>Match Hampers</span>
          </Link>
        </div>

        <ul className={`${styles.navLinks} ${isMenuOpen ? styles.show : ""}`} id="navLinks">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/products">Products</Link>
          </li>
          <li>
            <Link to="/occasions">Occasions</Link>
          </li>
          <li>
            <Link to="/customer-services">Customer Services</Link>
          </li>         
        </ul>

        <div className={styles.navActions}>          
          <Link
            className={`${commonStyles.btn}  ${commonStyles.btnPrimary}`}
            style={{ color: "white" }}
            to="/customer-services/Contact"
          >
            <FaPhone />
          </Link>
        </div>
      </nav>
    </header>
  );
}

export default Header;
